import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import ImageMapper from "react-image-mapper/lib/ImageMapper";
import { asset } from "Services/BaseHelpers";
import MapModel from "Components/Partials/Modals/MapModel";
import {Modal} from "Services";

export default class ExhibitorsMap extends React.Component {
    constructor(props) {
        super(props);

        this.SCALE = 1.33;
        this.IMAGE_URL = asset('/images/map/map-v4.png');
        this.aspectRatio = 3953 / 6599;
        this.fadeOutTimeout = null;

        this.AREAS_MAP = {
            name: "image-map",
            imgWidth: Math.round(6599 * this.SCALE),
            height: Math.round(3953 * this.SCALE),
            areas: [
                {
                    name: "Where you live",
                    shape: "poly",
                    coords: [2801,1831,3629,2303,3839,2245,4101,2332,4305,2105,4328,1918,4585,1755,4655,1609,4690,1440,4707,1067,4497,985,4358,974,3798,904,3623,915,3419,665,2941,1411].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/where-you-live.png'),
                    highlightedWidth: Math.round(260 * this.SCALE),
                    highlightedHeight: Math.round(215 * this.SCALE),
                    highlightedRight: Math.round(259 * this.SCALE),
                    highlightedTop: Math.round(105 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">
                                As cities grow and environmental challenges mount, urban design is becoming a health issue. Leaders, architects, and communities are rethinking how we build spaces that keep people well.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Our surroundings shape us in ways we don’t always see, clean air, green spaces, safe housing, and community connection all directly impact our physical and mental wellbeing.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                See how we are helping to make environments healthier:
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                <span className={"font-bold"}>
                                    Scroll down to explore our video content
                                </span>
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Camden Breathe Better Film<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1092395898?h=5e4f3d03e7&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>
                            <p className="text-sm leading-relaxed  my-5">
                                Healthy Cities Documentary<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1035992217?h=2ba5b6b07d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=5847"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Watch our sustainable Lego city take shape:<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126795645?h=c4a073fe17&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>
                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Bupa Campus",
                    shape: "poly",
                    coords: [3058,1143,3104,1044,3116,915,3151,752,3116,507,3017,408,2854,222,2568,146,2119,461,2026,828,2346,1137].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/bupa-campus.png'),
                    highlightedWidth: Math.round(260 * this.SCALE),
                    highlightedHeight: Math.round(165 * this.SCALE),
                    highlightedLeft: Math.round(208 * this.SCALE),
                    highlightedTop: Math.round(29 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">
                                <span className={"font-bold"}>Bupa Map:</span> See who we are and what we do around the world!
                            </p>

                            {/* NEW: Clickable Bupa Clinical provision link */}
                            <p className="text-sm leading-relaxed my-5">
                                <a
                                    href="https://www.bupa.com/site-services/bupa-map"
                                    className="text-blue-500 underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Bupa Clinical provision: News and stories from around Bupa-world
                                </a>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                <span className={"font-bold mb-4"}>Bupa Campus:</span>
                                <br />

                                <a
                                    href="https://stagingds.s3.eu-west-2.amazonaws.com/HealthQuest_Expo.pptx"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block bg-blue-600 text-white px-5 py-3  my-4 rounded-1xl hover:bg-blue-700"
                                    aria-label="Open HealthQuest presentation in a new tab"
                                >
                                    Open HealthQuest presentation (PowerPoint)
                                </a>
                                <br />
                                A groundbreaking new global learning programme offering our people a unique
                                opportunity to connect, collaborate and learn as the world around us continues to
                                rapidly transform.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Dedicated physical spaces and a global digital learning platform with industry-leading
                                virtual technology, allows our people to develop their skills for healthcare of
                                the future
                            </p>

                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Charging zone",
                    shape: "poly",
                    coords: [755,3609,872,3440,819,3113,755,2880,452,2979,259,3236,312,3527].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/charging-zone.png'),
                    highlightedWidth: Math.round(65 * this.SCALE),
                    highlightedHeight: Math.round(95 * this.SCALE),
                    highlightedLeft: Math.round(45 * this.SCALE),
                    highlightedBottom: Math.round(50 * this.SCALE),
                    description: null,
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Who you are",
                    shape: "poly",
                    coords: [2049,3854,2807,3877,2935,3592,3098,3469,3063,3271,3081,3032,2830,2857,2550,2659,2241,2734,1868,2717,1606,2874,1419,2927,1227,3084,1157,3253].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/who-you-are.png'),
                    highlightedWidth: Math.round(245 * this.SCALE),
                    highlightedHeight: Math.round(240 * this.SCALE),
                    highlightedLeft: Math.round(168 * this.SCALE),
                    highlightedTop: Math.round(325 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">One sequence can change everything. Inside each of us, a unique code. Three billion pieces of information that tells the story of who we are.</p>
                            <p className="text-sm leading-relaxed my-5">Our DNA influences far more than we might imagine, from our risk of developing certain diseases, to how we respond to treatments, and even aspects of our personality. Genomic advances mean we can act earlier, anticipate health challenges, and create personalised strategies for prevention and care.</p>
                            <p className="text-sm leading-relaxed my-5"><a href="#" className="text-blue-500 underline">Explore the power of genomics.</a></p>
                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "How you live",
                    shape: "poly",
                    coords: [1350,2921,1868,2682,1810,2525,1828,2297,1554,2029,1472,1819,1023,1755,866,1936,720,1697,405,1918,405,2122,201,2274,96,2490,254,2775,691,2845].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/how-you-live.png'),
                    highlightedWidth: Math.round(270 * this.SCALE),
                    highlightedHeight: Math.round(240 * this.SCALE),
                    highlightedLeft: Math.round(3 * this.SCALE),
                    highlightedTop: Math.round(200 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">
                                See how insights drive impact – and why small changes in daily life can create a huge
                                transformation.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Health data is only powerful when it’s used to make life better. That means connecting
                                people with the right support, at the right time, in ways that fit seamlessly into
                                daily life.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Explore mental health initiatives that are breaking stigma and remove barriers to care.
                            </p>
                            <p className="text-sm leading-relaxed my-5"><a href="#" className="text-blue-500 underline">
                                Take a break with mindplace</a>
                            </p>

                            <p className="text-sm leading-relaxed my-5 font-bold">
                                Scroll down to take a breath with Mindplace
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Meditation Centred on the Present Moment <br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126805775?h=0cdb6eaf56&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Meditation Centred on the Breath  <br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126805569?h=27b7827e1d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Observing Emotions<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126864589?h=9981e338e4&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Observing Thoughts<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126861871?h=ad1be2be03&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Relaxation Meditation<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126805488?h=37f5c46ca5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Visualisation Meditation<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126805356?h=b63b8df0cc&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Walk through the Forest<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126807502?h=83f78f2e00&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>

                            <p className="text-sm leading-relaxed my-5">
                                Way Home<br />
                                <div className="py-10 lg:py-20 flex items-center justify-center">
                                    <div className="max-w-4xl w-full">
                                        <div className="aspect-w-16 aspect-h-9">
                                            <iframe
                                                src="https://player.vimeo.com/video/1126805923?h=915ea96530&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameBorder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    </div>
                                </div>
                            </p>
                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Selfie wall",
                    shape: "poly",
                    coords: [4970,2565,5459,2414,5518,2233,5477,1895,5238,1667,4929,1656,4579,1877,4597,2128,4550,2338,4602,2460].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/selfie-station.png'),
                    highlightedWidth: Math.round(150 * this.SCALE),
                    highlightedHeight: Math.round(150 * this.SCALE),
                    highlightedRight: Math.round(164 * this.SCALE),
                    highlightedTop: Math.round(210 * this.SCALE),
                    description: null,
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Live on the Focus Stage",
                    shape: "poly",
                    coords: [5494,3731,5669,3504,5325,3143,5424,3096,5500,2869,5366,2630,4841,2688,4288,2834,4060,2979,3745,3364,3786,3539,4165,3871,4509,3918,5168,3924].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/focus-stage.png'),
                    highlightedWidth: Math.round(210 * this.SCALE),
                    highlightedHeight: Math.round(205 * this.SCALE),
                    highlightedRight: Math.round(164 * this.SCALE),
                    highlightedTop: Math.round(353 * this.SCALE),
                    description: null,
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Bupa Tech Lab",
                    shape: "poly",
                    coords: [4818,991,5080,717,5098,542,5110,280,4865,169,4462,17,4247,47,3623,292,3518,461,3431,630,3588,764,3915,875,4253,939].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/bupa-tech-lab.png'),
                    highlightedWidth: Math.round(267 * this.SCALE),
                    highlightedHeight: Math.round(260 * this.SCALE),
                    highlightedRight: Math.round(154 * this.SCALE),
                    highlightedTop: Math.round(-59 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">
                                Discover how Bupa Tech Lab is driving innovation
                                and empowering our people through the latest technology.
                            </p>
                            <p className="text-sm leading-relaxed my-5">
                                Hear from Roddy Barnes, Director of Technology Strategy &
                                Transformation, as he shares how Bupa Tech Lab is empowering
                                employee-led innovation with Accelerate – Bupa’s Global Hackathon.
                            </p>

                            <div className="py-10 lg:py-20 flex items-center justify-center">
                                <div className="max-w-4xl w-full">
                                    <div className="aspect-w-16 aspect-h-9">
                                        <iframe
                                            src="https://player.vimeo.com/video/1127180924?h=e2e3d69ab0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                            frameBorder="0"
                                            allow="autoplay; fullscreen; picture-in-picture"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
                {
                    name: "Movember",
                    shape: "poly",
                    coords: [6456,1988,5704,2017,5436,1761,5016,1522,4847,1393,5238,1137,5494,962,5658,764,5704,647,6211,880,6491,1131,6561,1213,6590,1224,6596,1545].map(v => Math.round(v * this.SCALE)),
                    highlightedImage: asset('/images/map/movember.png'),
                    highlightedWidth: Math.round(225 * this.SCALE),
                    highlightedHeight: Math.round(215 * this.SCALE),
                    highlightedRight: Math.round(3 * this.SCALE),
                    highlightedTop: Math.round(76 * this.SCALE),
                    description: (
                        <>
                            <p className="text-sm leading-relaxed my-5">
                                November turns into Movember. A month to grow a mo, spark
                                conversations, and take action for men’s health. From tackling mental
                                health and suicide prevention to raising awareness of prostate and
                                testicular cancer, Movember’s Barber Shop brings those chats to life,
                                because sometimes the best talks start in the chair.
                            </p>
                        </>
                    ),
                    preFillColor: "transparent",
                    fillColor: "transparent",
                },
            ]
        };

        this.state = {
            width: Math.min(window.innerWidth - 40, Math.round(900 * this.SCALE)),
            selectedArea: null,
            modalOpen: false,
            hoveredArea: null,
            tooltipVisible: false,
            showTooltip: false,
            mouseX: 0,
            mouseY: 0,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    updateWidth = () => {
        this.setState({ width: Math.min(window.innerWidth - 40, Math.round(900 * this.SCALE)) });
    };

    handleAreaEnter = (area, index, event) => {
        if (this.fadeOutTimeout) {
            clearTimeout(this.fadeOutTimeout);
            this.fadeOutTimeout = null;
        }
        const fullArea = this.AREAS_MAP.areas.find(a => a.name === area.name) || area;
        this.setState({
            hoveredArea: fullArea,
            mouseX: this.getRelativeX(event),
            mouseY: this.getRelativeY(event),
            tooltipVisible: true,
        }, () => setTimeout(() => this.setState({ showTooltip: true }), 10));
    };

    handleAreaMove = (area, index, event) => {
        this.setState({
            mouseX: this.getRelativeX(event),
            mouseY: this.getRelativeY(event),
        });
    };

    handleAreaLeave = () => {
        this.setState({ showTooltip: false });
        this.fadeOutTimeout = setTimeout(() => {
            this.setState({ hoveredArea: null, tooltipVisible: false });
            this.fadeOutTimeout = null;
        }, 200);
    };

    handleAreaClick = (area, index, event) => {
        const fullArea = this.AREAS_MAP.areas.find(a => a.name === area.name) || area;
        // don't open modal for areas that have no description
        if (!fullArea || fullArea.description == null) return;
        Modal.open({
            component: MapModel,
            props: {
                selectedArea: fullArea
            }
        });
    };

    handleAreaTouchStart = (area, index, event) => {
        if (event.touches && event.touches.length > 0) {
            const fullArea = this.AREAS_MAP.areas.find(a => a.name === area.name) || area;
            // don't open modal for areas that have no description
            if (!fullArea || fullArea.description == null) return;
            //this.setState({ selectedArea: fullArea, modalOpen: true });
            Modal.open({
                component: MapModel,
                props: {
                    selectedArea: fullArea
                }
            });
        }
    };

    getRelativeX = (event) => {
        const container = this.imageContainerRef;
        if (!container) return 0;
        const rect = container.getBoundingClientRect();
        return Math.min(Math.max((event.clientX || event.pageX) - rect.left, 0), rect.width - 10);
    };

    getRelativeY = (event) => {
        const container = this.imageContainerRef;
        if (!container) return 0;
        const rect = container.getBoundingClientRect();
        return Math.min(Math.max((event.clientY || event.pageY) - rect.top, 0), rect.height - 10);
    };

    setImageContainerRef = (ref) => {
        this.imageContainerRef = ref;
    };

    render() {
        const { width, hoveredArea, showTooltip } = this.state;
        const height = Math.round(width * this.aspectRatio);

        const mapperForImageMapper = {
            ...this.AREAS_MAP,
            areas: this.AREAS_MAP.areas.map(({ description, preFillColor, ...rest }) => {
                const isHovered = hoveredArea && hoveredArea.name === rest.name;
                return {
                    ...rest,
                    preFillColor:'transparent'
                };
            })
        };

        return (
            <Authenticated pageVideoHeader={"bupa-banner.mp4"} title={"Dashboard"}>
                <div
                    className="mx-auto my-10"
                    style={{
                        width: "100%",
                        maxWidth: Math.round(900 * this.SCALE),
                        height: height,
                        position: "relative",
                        touchAction: "manipulation",
                        overflow: "visible",
                    }}
                    ref={this.setImageContainerRef}
                >
                    <ImageMapper
                        src={this.IMAGE_URL}
                        map={mapperForImageMapper}
                        width={width}
                        height={height}
                        imgWidth={Math.round(6599 * this.SCALE)}
                        onClick={this.handleAreaClick}
                        onTouchStart={this.handleAreaTouchStart}
                        onMouseEnter={this.handleAreaEnter}
                        onMouseLeave={this.handleAreaLeave}
                        onMouseMove={this.handleAreaMove}
                        fillColor="none"
                        strokeColor="transparent"
                        lineWidth={0}
                    />

                    {hoveredArea && (
                        <>
                            <div style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: width,
                                height: height,
                                background: "rgba(0,0,0,0.7)",
                                pointerEvents: "none",
                                zIndex: 2,
                                overflow: "hidden",
                                maxHeight: Math.round(3953 * this.SCALE),
                                maxWidth: Math.round(6599 * this.SCALE),
                                opacity: showTooltip ? 1 : 0,
                                transition: "opacity 0.2s",
                            }} />
                            {width > 600 && hoveredArea.highlightedImage && (
                                <img
                                    src={hoveredArea.highlightedImage}
                                    alt="highlighted"
                                    style={{
                                        position: "absolute",
                                        ...(hoveredArea.highlightedTop !== undefined && { top: hoveredArea.highlightedTop }),
                                        ...(hoveredArea.highlightedLeft !== undefined && { left: hoveredArea.highlightedLeft }),
                                        ...(hoveredArea.highlightedRight !== undefined && { right: hoveredArea.highlightedRight }),
                                        ...(hoveredArea.highlightedBottom !== undefined && { bottom: hoveredArea.highlightedBottom }),
                                        width: hoveredArea.highlightedWidth,
                                        height: hoveredArea.highlightedHeight,
                                        objectFit: "contain",
                                        zIndex: 3,
                                        pointerEvents: "none",
                                        opacity: showTooltip ? 1 : 0,
                                        transition: "opacity 0.2s",
                                    }}
                                />
                            )}
                        </>
                    )}
                </div>
            </Authenticated>
        );
    }
}
